export default {
    medicalSpecialty: 'medicalSpecialty',
    medicalSpecialtiesTitle: 'Title',
    medicalSpecialtiesStatus: 'Status',
    medicalSpecialties: 'medicalSpecialties',
    editMedicalSpecialties: 'Edit Medical Specialties',
    addMedicalSpecialties: 'Add Medical Specialties',
}